/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {Box, Link, Container} from "theme-ui";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    a: "a",
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    sx: {
      mt: 30,
      mx: "auto",
      pb: 120,
      width: [1, 1, 1 / 2]
    }
  }, React.createElement(_components.h2, {
    id: "this-content-is-exclusive-for-students"
  }, React.createElement(_components.a, {
    href: "#this-content-is-exclusive-for-students"
  }, "This content is exclusive for students")), React.createElement(_components.p, null, "Please login to view this page."), React.createElement(_components.p, null, "You can still become a student!")), "\n", React.createElement(Container, {
    sx: {
      textAlign: 'center',
      width: [1, 3 / 4, 1 / 2],
      mb: [4, 4, 5]
    }
  }, React.createElement(_components.p, null, "30 day moneyback guarantee.")));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
